import { useCallback } from 'react'

import type { LocationCandidate } from './types'
import { searchLocator } from './index'


export const useAddressToLocations = () => {
  const addressSearch = useCallback(async (address) => {
    if (!address || address.trim() === '') return []
    return searchLocator(address)
  }, []) as (address: string) => Promise<LocationCandidate[]>

  return addressSearch
}